import { render, staticRenderFns } from "./Installationsfleet.vue?vue&type=template&id=67022340&scoped=true"
import script from "./Installationsfleet.vue?vue&type=script&lang=js"
export * from "./Installationsfleet.vue?vue&type=script&lang=js"
import style0 from "./Installationsfleet.vue?vue&type=style&index=0&id=67022340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67022340",
  null
  
)

export default component.exports